import _extends from "@babel/runtime/helpers/extends";
import React, { lazy, Suspense } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ExportAppContainer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: 'successstorieslist' */'./');
});
export default (function (props) {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: /*#__PURE__*/_jsx("div", {}),
    children: /*#__PURE__*/_jsx(ExportAppContainer, _extends({}, props))
  });
});